import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_SALESPUBLIC,
  GET_SALESPUBLIC_ONE,
  DELETE_SALESPUBLIC,
  UPDATE_SALESPUBLIC,
  ADD_NEW_SALESPUBLIC,
} from "./actionType";

import {
  getSalesPublicSuccess,
  getSalesPublicFail,
  deleteSalesPublicSuccess,
  deleteSalesPublicFail,
  updateSalesPublicSuccess,
  updateSalesPublicFail,
  addSalesPublicSuccess,
  addSalesPublicFail,
  getSalesPublicLoading,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approveSalesPublicApi,
  getSalesPublicApi,
  updateSalesPublicApi,
  deleteSalesPublicApi,
  addNewSalesPublicApi,
  getOneSalesPublicApi
} from "../../helpers/backend_helper";

function* getSalesPublic({ payload: salesPublic }) {
  try {
    const response = yield call(getSalesPublicApi, salesPublic);
    yield put(getSalesPublicSuccess(GET_SALESPUBLIC, response.data));
  } catch (error) {
    yield put(getSalesPublicFail(GET_SALESPUBLIC, error));
  }
}

function* getSalesPublicOne({ payload: id }) {
  try {
    const response = yield call(getOneSalesPublicApi, id);
    yield put(getSalesPublicSuccess(GET_SALESPUBLIC_ONE, response));
  } catch (error) {
    yield put(getSalesPublicFail(GET_SALESPUBLIC_ONE, error));
  }
}

function* onUpdateSalesPublic({ payload: salesPublic }) {
  try {
    yield put(getSalesPublicLoading());
    if (salesPublic.setApprove) {
      const response = yield call(approveSalesPublicApi, salesPublic);
      yield put(updateSalesPublicSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateSalesPublicApi, salesPublic);
      yield put(updateSalesPublicSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateSalesPublicFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteSalesPublic({ payload: salesPublic }) {
  try {
    yield put(getSalesPublicLoading());
    const response = yield call(deleteSalesPublicApi, salesPublic);
    yield put(deleteSalesPublicSuccess({ salesPublic, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteSalesPublicFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewSalesPublic({ payload: salesPublic }) {
  try {
    yield put(getSalesPublicLoading());
    const response = yield call(addNewSalesPublicApi, salesPublic);
    yield put(addSalesPublicSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addSalesPublicFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetSalesPublic() {
  yield takeEvery(GET_SALESPUBLIC, getSalesPublic);
}

export function* watchGetSalesPublicOne() {
  yield takeEvery(GET_SALESPUBLIC_ONE, getSalesPublicOne);
}

export function* watchUpdateSalesPublic() {
  yield takeEvery(UPDATE_SALESPUBLIC, onUpdateSalesPublic);
}

export function* watchDeleteSalesPublic() {
  yield takeEvery(DELETE_SALESPUBLIC, onDeleteSalesPublic);
}

export function* watchAddNewSalesPublic() {
  yield takeEvery(ADD_NEW_SALESPUBLIC, onAddNewSalesPublic);
}

function* salesPublicSaga() {
  yield all([
    fork(watchGetSalesPublic),
    fork(watchGetSalesPublicOne),
    fork(watchDeleteSalesPublic),
    fork(watchUpdateSalesPublic),
    fork(watchAddNewSalesPublic)
  ]);
}

export default salesPublicSaga;
